import { THC_CBD_Group, THC_CBD_Mapping } from './shared.model'

export const THC_CBD_CardList: THC_CBD_Group[] = [
    {
        No: 1,
        Title: "CBD Dominant",
        THC: { Value: 1, Min: 0, Max: 2 },
        CBD: { Value: 10, Equality: ">", Min: 5, Max: 0 }
    },
    {
        No: 2,
        Title: "THC / CBD Ausgeglichen",
        THC: { Value: 10, Min: 2, Max: 0 },
        CBD: { Value: 10, Min: 2, Max: 0 }
    },
    {
        No: 3,
        Title: "THC Dominant",
        THC: { Value: 10, Min: 5, Max: 0 },
        CBD: { Value: 1, Min: 0, Max: 2 }
    }
];

export const ICDCodeMappings: THC_CBD_Mapping[] = [
    { Code: "R52.1", MapTo: [3] },
    { Code: "R52.2", MapTo: [3] },
    { Code: "R29.8", MapTo: [3] },
    { Code: "R11", MapTo: [3] },
    { Code: "R63.0", MapTo: [3] },
    { Code: "G35", MapTo: [2] },
    { Code: "F95.2", MapTo: [3] },
    { Code: "G40", MapTo: [1] },
    { Code: "F51", MapTo: [1] },
    { Code: "F42", MapTo: [1] },
    { Code: "F90.0", MapTo: [2] },
    { Code: "F43.1", MapTo: [2, 3] },
    { Code: "C22.9", MapTo: [1] },
    { Code: "F45.41", MapTo: [2] },
    { Code: "B20", MapTo: [2] },
    { Code: "R50.0", MapTo: [3] },
    { Code: "R64", MapTo: [3] }
];
